import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

function SafeDrivingNightLoadingKr() {
  const {t} = useInferableTranslation();

  return (
    <div className="section_container safe_driving_night skeleton">
      <div className="section_container_header">
        <h3 className="title_xxsmall">{t('T20000')}</h3>
      </div>
      <p
        className="section_container_desc"
        style={{whiteSpace: 'pre-wrap'}}
      >
        {t('T20136')}
      </p>

      <ul className="statistics_info_list">
        <li className="statistics_info_item">
          <span
            className="statistics_info_key"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('T20137')}
          </span>
          <span className="statistics_info_val">
            <span className="statistics_info_number">{10}</span>
            <span className="statistics_info_unit">{t('T20133')}</span>
          </span>
        </li>
        <li className="statistics_info_item">
          <span
            className="statistics_info_key"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('T20138')}
          </span>
          <span className="statistics_info_val">
            <span className="statistics_info_number">{9}</span>
            <span className="statistics_info_unit">{t('T20133')}</span>
          </span>
        </li>
      </ul>
    </div>
  );
}

export default SafeDrivingNightLoadingKr;
